import React, { useState } from 'react'
import styled from 'styled-components'
import TangramTokens from '../../lib/tangramNextConfig'
import { SCREEN_SIZE } from '../../lib/Media'

import AppLogo from '../icons/svg/logo.svg'
import { Button, Text, CloseIcon, ConfigProvider } from '@ntuctech/tangram-web'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'

const FixedBottomContainer = styled.div`
  z-index: 1;
  display: flex;
  ${SCREEN_SIZE.From.Tablet} {
    display: none;
  }

  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  padding: 1rem;

  background-color: ${TangramTokens.colors.primary700};
  color: ${TangramTokens.colors.white};
`

const Section = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const AppLogoImage = styled.img`
  width: 2.5rem;
  height: 2.5rem;
`

const CloseIconButton = styled(CloseIcon)`
  font-size: 1.5rem;
`

export default function SmartBanner() {
  const { isEnabled: isGetAppMenuEnabled, configuration: getAppConfiguration } =
    getConfigFor(SPLIT_FEATURES.FE_ENGM_GET_APP_MENU)

  const [bannerShown, setBannerShown] = useState(isGetAppMenuEnabled)

  return (
    <ConfigProvider
      tokens={TangramTokens}
      experimental={{
        Text: true,
        Button: true,
      }}
    >
      {bannerShown && (
        <FixedBottomContainer>
          <Section>
            <AppLogoImage src={AppLogo} />
            <Text size="s" color="inherit">
              {getAppConfiguration.bannerLabel}
            </Text>
          </Section>
          <Section>
            <Button
              variant="primary-dark"
              size="s"
              onClick={() => {
                window.open(
                  getAppConfiguration.bannerDownloadAppUrl,
                  '_blank',
                  'noopener,noreferrer'
                )
              }}
            >
              {getAppConfiguration.bannerDownloadLabel}
            </Button>
            <CloseIconButton
              data-testid="smart_banner_close"
              onClick={() => {
                setBannerShown(false)
              }}
            />
          </Section>
        </FixedBottomContainer>
      )}
    </ConfigProvider>
  )
}
